import { ApiMananger } from "actions/rtkquery";
import { GET_PRODUITS_API_ROUTE } from "routes/api/endpoints";
import { INVALIDATE_PRODUITS } from "../invalidationTags";

const produitApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({

    getProduits: build.query({
        query: ({ dossier_id }) => `${GET_PRODUITS_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_PRODUITS],
    }),
    getProduitsId: build.query({
        query: ({ dossier_id, id }) => `${GET_PRODUITS_API_ROUTE}?dossier_id=${dossier_id}&id=${id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_PRODUITS],
    }),
}),
});

export const {
useGetProduitsQuery,
useGetProduitsIdQuery,
} = produitApi;
